<script lang="ts">
import type { DropdownMenuItem } from '@nuxt/ui';
import { isNullishOrEmpty } from '#layers/base/public';

export interface SidebarAction {
	id?: string;
	label?: string;
	icon?: string;
	color?: DropdownMenuItem['color'];
	type?: DropdownMenuItem['type'];
	disabled?: DropdownMenuItem['disabled'];
	onSelect?: DropdownMenuItem['onSelect'];
}
</script>

<script setup lang="ts">
import { computed } from 'vue';

const { actions } = defineProps<{
	actions?: SidebarAction[];
}>();

const shortcutAction = computed(() => actions?.[0]);
</script>

<template>
	<div class="flex items-center gap-1">
		<!-- First action is repeated as a shortcut before the dropdown menu -->
		<DTooltip v-if="shortcutAction" :text="shortcutAction.label">
			<DButton
				variant="ghost"
				color="neutral"
				:icon="shortcutAction.icon"
				size="sm"
				@click="shortcutAction.onSelect"
			/>
		</DTooltip>
		<DDropdownMenu
			v-if="!isNullishOrEmpty(actions)"
			:items="actions"
			:content="{ side: 'bottom' }"
			:ui="{ content: 'min-w-auto' }"
		>
			<template #default="{ open }">
				<DTooltip :text="$t('common.more')">
					<DButton
						variant="ghost"
						color="neutral"
						icon="lucide:ellipsis"
						size="sm"
						class="text-muted hover:text-highlighted focus-visible:text-highlighted"
						:class="{
							'bg-elevated': open,
						}"
					/>
				</DTooltip>
			</template>
		</DDropdownMenu>
	</div>
</template>
